export const pubMedBaseUrl = 'https://pubmed.ncbi.nlm.nih.gov/';
